import { ApiService } from "../../../core/services/api.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/catch";
import { AuthenticationService } from "../../../core/services/authentication.service";
import { HandleErrorService } from "../../../core/services/handle-error.service";
import { HousesService } from "../../../entities/houses/houses.service";
import { SessionStateService } from "../../../core/services/session-state.service";
import { DevicesService } from "../../../entities/devices/devices.service";
import { JwtService } from "../../../core/services";
import { onErrorResumeNext } from "rxjs/observable/onErrorResumeNext";
import { empty } from "rxjs/Observer";
import { Router } from "@angular/router";
import { Constants } from "../../../core/services/constants";
import { House } from "../../../entities/houses/houses.model";
import { GeneralService } from "../../services/general.service";
import { environment } from "../../../../environments/environment";
import { of } from "rxjs/observable/of";
import { CookieService } from "ngx-cookie-service";
@Injectable()
export class LoginService {
  constructor(
    private authenticationService: AuthenticationService,
    private apiService: ApiService,
    private sessionStateService: SessionStateService,
    private handleErrorService: HandleErrorService,
    private housesService: HousesService,
    private devicesService: DevicesService,
    private generalService: GeneralService,
    private router: Router,
    private cookiesService: CookieService
  ) {}

  signIn(username: string, password: string): Observable<any> {
    return this.authenticationService
      .login(username, password)
      .catch((err) => {
        const message = "[EMCP] - Repeat Cognito SDK interaction.";

        if (environment.inDev === true) {
          if (err.message.includes(message) === true) {
            return this.authenticationService
              .login(username.toLocaleLowerCase(), password)
              .catch((err) => {
                if (
                  err.code === Constants.COGNITO_EXCETPION.USER_NOT_CONFIRMED
                ) {
                  this.sessionStateService.setFirstLogin(
                    username.toLocaleLowerCase()
                  );
                  this.sessionStateService.setCoachMarkState(
                    true,
                    username.toLocaleLowerCase()
                  );
                  this.sessionStateService.initializeCoachMarkIndividualState(
                    true
                  );
                  this.router.navigate(["/confirmaccount"]);
                }

                return this.authenticationService.login(
                  username.toLocaleLowerCase(),
                  password
                );
              });
          }
        }

        if (err.code === Constants.COGNITO_EXCETPION.USER_NOT_CONFIRMED) {
          this.sessionStateService.setFirstLogin(username.toLocaleLowerCase());
          this.sessionStateService.setCoachMarkState(
            true,
            username.toLocaleLowerCase()
          );
          this.sessionStateService.initializeCoachMarkIndividualState(true);
          this.router.navigate(["/confirmaccount"]);
        }

        return this.authenticationService.login(
          username.toLocaleLowerCase(),
          password
        );
      })
      .flatMap((res) => {
        return this.authenticationService.getSession().map(() => {
          this.sessionStateService.setUsername(username.toLocaleLowerCase());
        });
      })
      .catch((err) => {
        return this.handleErrorService.handleCognitoResponseError(err);
      })
      .flatMap(() =>
        this.housesService
          .getHouses()
          .map((res) => {
            const clientHouses = res;
            if (!this.sessionStateService.getHouse()) {
              let selectedHouseIndex = 0;

              // If exists RedirectURL, so this block of code may verify if the redeirectUrl contains houseId
              // If redirectURL contains houseId, then the user will be automatically redirected to this house
              if (
                this.cookiesService.get("redirectUrl") &&
                this.cookiesService.get("redirectUrl") !== "null"
              ) {
                if (this.cookiesService.get("redirectUrl").indexOf("houseId")) {
                  const _urlParams = localStorage
                    .getItem("redirectUrl")
                    .substring(
                      this.cookiesService
                        .get("redirectUrl")
                        .indexOf("houseId") + 8,
                      this.cookiesService.get("redirectUrl").toString().length
                    );
                  for (let index = 0; index < clientHouses.length; index++) {
                    const _elHouse: House = clientHouses[index];
                    if (_elHouse.houseId === _urlParams) {
                      selectedHouseIndex = index;
                    }
                  }
                }
              }

              this.sessionStateService.setHouse(
                clientHouses[selectedHouseIndex]
              );
            }
          })
          .catch((err) => {
            if (!this.generalService.isMobile()) {
              this.router.navigate(["no-house-user"]);
            } else {
              this.router.navigate(["home"]);
            }
            return Observable.empty();
          })
          .flatMap(() =>
            this.devicesService
              .getHouseDevice(this.sessionStateService.getHouse().houseId)
              .map((response) => {
                response.forEach((smartDevice) => {
                  const smartDevicesItems = [
                    { type: "redybox" },
                    { type: "wifi" },
                  ];
                  const smartDevicesToSet = [];

                  for (const item of smartDevicesItems) {
                    if (item.type === smartDevice.type) {
                      smartDevicesToSet.push(smartDevice);
                    }
                  }

                  this.sessionStateService.setSmartDevices(smartDevice);
                });
              })
              .catch((err) => {
                return of(empty);
              })
          )
          .flatMap(() =>
            this.housesService
              .getHouseTariff(this.sessionStateService.getHouse().houseId)
              .map((response) => {
                if (response.electricity) {
                  this.sessionStateService.setHouseTariff({
                    tariff: response.electricity.hourOption,
                    cycle: response.electricity.cycle,
                  });
                }
                if (response.gas) {
                  this.sessionStateService.setHouseTariff({
                    tariff: response.gas.hourOption,
                    cycle: response.gas.cycle,
                    geography: response.gas.geography,
                    costRate: response.gas.costRate,
                  });
                }
              })
              .catch((err) => {
                // console.log('No house Tariff found');
                return of(empty);
              })
          )
      );
  }

  sendRecoveryEmail(username: string): Observable<any> {
    return this.authenticationService
      .forgotPassword(username.toLocaleLowerCase())
      .catch((err) => {
        const message = "[EMCP] - Repeat Cognito SDK interaction.";

        if (environment.inDev === true) {
          if (err.message.includes(message)) {
            return this.authenticationService
              .forgotPassword(username.toLocaleLowerCase())
              .catch((err) => {
                return this.handleErrorService.handleCognitoResponseError(err);
              });
          }
        }

        return this.handleErrorService.handleCognitoResponseError(err);
      });
  }

  setNewPassword(
    username: string,
    verificationCode: string,
    newPassword: string
  ): Observable<any> {
    return this.authenticationService
      .confirmPassword(
        username.toLocaleLowerCase(),
        verificationCode,
        newPassword
      )
      .catch((err) => this.handleErrorService.handleCognitoResponseError(err));
  }

  private newPasswordRequest(ticket: String, id: String, newPassword: String) {
    const body = {
      Parameters: {
        Token: ticket,
        UserId: id,
        NewPassword: newPassword,
      },
    };
    return this.apiService.post("/UIAPI/Users/FinishPasswordRecovery", body);
  }

  confirmAccount(
    email: string,
    oldPassword: string,
    newPassword: string
  ): Observable<any> {
    const body = {
      email: email,
      password: oldPassword,
      newPassword: newPassword,
    };
    return this.apiService.post(
      "/usermanagement/user/account-confirmation",
      body
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/login.service.ts